import React, { createContext, useContext, useState } from 'react';
import './Confirm.css';

const ConfirmContext = createContext();

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within ConfirmProvider');
  }
  return context;
};

export const ConfirmProvider = ({ children }) => {
  const [confirm, setConfirm] = useState(null);

  const showConfirm = (message, onConfirm) => {
    setConfirm({ message, onConfirm });
  };

  const hideConfirm = () => {
    setConfirm(null);
  };

  const handleConfirm = () => {
    if (confirm && confirm.onConfirm) {
      confirm.onConfirm();
    }
    hideConfirm();
  };

  return (
    <ConfirmContext.Provider value={{ showConfirm }}>
      {children}
      {confirm && (
        <div className="confirm-overlay" onClick={hideConfirm}>
          <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="confirm-content">
              <div className="confirm-icon">⚠</div>
              <div className="confirm-message">{confirm.message}</div>
            </div>
            <div className="confirm-actions">
              <button className="btn btn-secondary" onClick={hideConfirm}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleConfirm}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};

